import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';
import type { ColorSwatchProps } from './ColorSwatch.types';

const styles = stylex.create({
  button: {
    boxSizing: 'border-box',
    padding: 0,
    cursor: 'pointer',
    borderWidth: controlMetrics.borderWidth,
    borderStyle: 'solid',
    borderColor: colors.swatchBorder,
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    outlineStyle: { 'default': null, ':focus-visible': 'none' },
  },
});
const sizes = stylex.create({
  sm: { width: '1.25rem', height: '1.25rem', borderRadius: '0.25rem' },
  md: { width: '1.5rem', height: '1.5rem', borderRadius: controlMetrics.radius },
  lg: { width: '2rem', height: '2rem', borderRadius: '0.5rem' },
});

const ColorSwatch = forwardRef<HTMLButtonElement, ColorSwatchProps>(function ColorSwatch(
  { color, onClick, 'aria-label': ariaLabel, size = 'lg', extraClassNames = '', xstyle, id, testId },
  ref,
) {
  const styleProps = stylex.props(styles.button, sizes[size], xstyle);
  return (
    <button
      ref={ref}
      aria-label={ariaLabel}
      className={clsx(styleProps.className, extraClassNames)}
      data-testid={testId}
      id={id}
      onClick={onClick}
      style={{ ...styleProps.style, backgroundColor: color }}
      type="button"
    />
  );
});

export default ColorSwatch;
